import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const FooterContainer = styled(Box)(`
  display:flex;
  justify-content: space-between;
  align-items: center;
  height: 47px;
  min-height: 47px;
  padding: 0px 16px;
  border-top: 1px solid #E7E7E6;
  position: relative;
`)

export const FooterWrapperMain = styled(Box)(`
  position: relative;
`)

export const PrivacyText = styled(Box)(`
  display: flex;
  font-size: 12px;
  line-height: 16px;
  align-items: center;
  flex: 1;
`)
export const PrivacyLink = styled('a')(`
  all:unset;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
    color: #095BBD;
  }
`)

export const RightSideFooter = styled(Box)(`
  display: flex;
  align-items: center;
  font-size: 16px;
  gap: 4px;
  color: #8B8B89;
`)

export const CompanyLogo = styled('img')(``)
